import apiClient from "QueryClient/axiosClient";

export const logoutUser = async () => {
  return apiClient.post(`/auth/logout`);
};
